import { IControlField2, IFieldResponse } from './control-field.base';

export interface IToggleControlField extends IControlField2 {
  default_value?: boolean;
}

export function toToggleField(field: IFieldResponse): IToggleControlField {
  return {
    id: field.id,
    alias: field.alias,
    control_type: field.control_type,
    default_value: field.default_value as boolean,
    helper_text: field.helper_text,
    is_visible: field.is_visible,
    is_active: field.is_active,
    is_disabled: field.is_disabled,
    is_mandatory: field.is_mandatory,
    is_hierarchical: field.is_hierarchical,
    name: field.name,
    placement_order: field.placement_order,
    section: field.section,
    dtype: field.dtype,
    is_auto_fill: field.is_auto_fill,
    planner_flag: field.planner_flag,
    info_details: field.info_details,
    is_info_enable: field.is_info_enable
  };
}
